<template>
	<div id='leaveapplication'>
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
						<a-row type='flex' justify='space-between'>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="員工姓名" class="formItem">
									<a-input v-model="params.ename" placeholder="請輸入員工姓名" :allowClear="true" @change="handleClear()"/>
								</a-form-model-item>
							</a-col>
							
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="申請類別" class="formItem">
									<a-select v-model="params.applytype" placeholder="請選擇假期類別" @change="searchEvent">
										<a-select-option v-for="(item) in admintypeArrs" :key="item.key"
											:value="item.value">{{item.text}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="部門" class="formItem">
									<!-- <a-select v-model="params.department" placeholder="請選擇部門">
										<a-select-option v-for="(item) in admintypeArr" :key="item.key"
											:value="item.value">{{item.text}}</a-select-option>
									</a-select> -->
									<Situationall v-model="params.department" :url='$api.getParamList' :route1="routeFlag"
										:params='{"type":"department"}' :style='"width:100%"' :placeholder="'請選擇部門'">
									</Situationall>
								</a-form-model-item>
							</a-col>
							</a-row><br>
							<a-row type='flex' justify='space-between'>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="批核狀況" class="formItem">
									<a-select v-model="params.status" placeholder="請選擇批核狀況" @change="searchEvent">
										<a-select-option v-for="(item) in khtypeArr" :key="item.key"
											:value="item.value">{{item.text}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="申請日期" class="formItem">
									<a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD"
										v-model="params.timeDate" @change='fanhand'>
									</a-range-picker>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 6 }" style="display: flex;align-items: center;">
								<div class="btn_cla" style="background-color:#3bc7a1;margin-right: 1rem;" @click="searchEvent">
									<img src="../../image/icon_sousuo.png" class="btnIcon" />
									<span>搜索</span>
								</div>
								<div class="btn_cla" style="background-color:#ffa647;"
									@click="clearEvent">
									<img src="../../image/icon_chongzhi.png" class="btnIcon" />
									<span>重置</span>
								</div>
							</a-col>
						</a-row>
				
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
				<div class="bottomBtn" style="color:#3bc7a1;" @click='handDelect({type:2})'>
					<img src="../../image/lea/xiujia.png" class="btnIcon" />
					<span>申請假期</span>
				</div>
				<div class="bottomBtn" style="color:#ffa647;" @click='handDelect({type:4})'>
					<img src="../../image/lea/waichu.png" class="btnIcon" />
					<span>申請外出</span>
				</div>
				<div class="bottomBtn" style="color:#349ce5;" @click='handDelect({type:3})'>
					<img src="../../image/lea/jiaban.png" class="btnIcon" />
					<span>申請加班</span>
				</div>
				<div class="bottomBtn" style="color:#f57575;"  @click='handDelect({type:1})' v-if='attenceAdmin2'>
					<img src="../../image/lea/wenju.png" class="btnIcon" />
					<span>辦工用品</span>
				</div>
				<task :params='params' @child='fandfn' :pasadate='rewulist'></task>
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
				:rowKey='(record, index) => index'
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }" :pagination="false"
				:bordered="true">
				<span slot='alltext' style="font-size: 0.85rem;position: relative;left: -1.5rem;"></span>
				<!-- :scroll="{ y: 'calc(100vh - 430px)', x: '100vw'}" -->

				<div slot='createtime' slot-scope="record" style="white-space: nowrap;" :title='record.stockname'>
					<div v-if='!record.createtime'>
						<div class="bottomBtn" style="color:#ffa647;" @click="handDelect(record)">
							<span style="text-decoration:underline;cursor:pointer;">未提交</span>
						</div>
					</div>
					<div v-if='record.createtime'>
						{{record.createtime}}
					</div>
				</div>
				<div slot='status' slot-scope='record'>
					<div v-if='record.status == 2' @click='fourfn(record)' style='color: red;'
						:style="{'textDecoration':1==record.isuserself?'underline':''}">審核拒絕</div>
					<div v-else-if='0<record.status'>已審批</div>
					<div v-else style="color: #ff6649;">未審批</div>
				</div>
				<div slot='type' slot-scope='record'>
					<div v-if='2==record.type' style="color: #3bc7a1;">假期</div>
					<div v-if='4==record.type' style="color: #ffa647;">外出</div>
					<div v-if='3==record.type' style="color: #349ce5;">加班</div>
					<div v-if='1==record.type' style="color: #f57575;">辦工用品</div>
				</div>
				<!-- 显示状态 -->
				<div slot="schedule" slot-scope="record">
					<div class="tableRowView1" v-if='1==record.type'>
						<img :src="icon_four" alt="" class="imageC">
						<div class="lineC line-w"
							:style="record.schedule >0||(record.schedule == 0&&record.handle == 1)? 'background:#e85567;' : ''">
							<span v-if="record.schedule == 0&&record.handle == 2" class="redX">x</span>
						</div>
						<!-- <img :src="record.schedule > 0||(record.handle == 1&&record.schedule == 1) ? icon_one : icon_one1"
							alt="" class="imageC">
						<div class="lineC line-w"
							:style="record.schedule >1||(record.schedule == 1&&record.handle == 1) ? 'background:#467fff;' : ''">
							<span v-if="record.schedule == 1&&record.handle == 2" class="redX">x</span>
						</div> -->
						<img :src="record.schedule > 1||(record.schedule == 2&&record.handle == 1) ? icon_amd : icon_amd1"
							alt="" class="imageC">
						<!-- 狀態四拒絕第三條線變灰色帶x -->
						<div class="lineC line-w" v-if='record.schedule == 4&&record.handle == 2'>
							<span class="redX">x</span>
						</div>
						<div class="lineC line-w" v-else
							:style="record.schedule >2||(record.schedule == 2&&record.handle == 1)? 'background:#6cce68;' : ''">
							<span v-if="record.schedule == 2&&record.handle == 2" class="redX">x</span>
						</div>
						<img v-if='record.schedule == 4&&record.handle == 2' :src="icon_three4" alt="" class="imageC">
						<img v-else
							:src="(record.schedule == 4&&record.handle == 1)? icon_three2 : (record.schedule == 3&&record.handle == 1)||(record.schedule == 4&&record.handle == 0)?icon_three1 :icon_three"
							alt="" class="imageC">
					</div>
					<div class="tableRowView1" v-else>
						<img :src="icon_four" alt="" class="imageC">
						<div class="lineC"
							:style="record.schedule >0||(record.schedule == 0&&record.handle == 1)? 'background:#e85567;' : ''">
							<span v-if="record.schedule == 0&&record.handle == 2" class="redX">x</span>
						</div>
						<img :src="record.schedule > 0||(record.handle == 1&&record.schedule == 1) ? icon_one : icon_one1"
							alt="" class="imageC">
						<div class="lineC"
							:style="record.schedule >1||(record.schedule == 1&&record.handle == 1) ? 'background:#467fff;' : ''">
							<span v-if="record.schedule == 1&&record.handle == 2" class="redX">x</span>
						</div>
						<img :src="record.schedule > 1||(record.schedule == 2&&record.handle == 1) ? icon_two : icon_two1"
							alt="" class="imageC">
						<!-- 狀態四拒絕第三條線變灰色帶x -->
						<div class="lineC" v-if='record.schedule == 4&&record.handle == 2'>
							<span class="redX">x</span>
						</div>
						<div class="lineC" v-else
							:style="record.schedule >2||(record.schedule == 2&&record.handle == 1)? 'background:#6cce68;' : ''">
							<span v-if="record.schedule == 2&&record.handle == 2" class="redX">x</span>
						</div>
						<img v-if='record.schedule == 4&&record.handle == 2' :src="icon_three4" alt="" class="imageC">
						<img v-else
							:src="(record.schedule == 4&&record.handle == 1)? icon_three2 : (record.schedule == 3&&record.handle == 1)||(record.schedule == 4&&record.handle == 0)?icon_three1 :icon_three"
							alt="" class="imageC">
					</div>
				</div>
				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<div class="tableRowView2">
						<div class="popoverView" v-if='attenceAdmin3&&record.schedule > 3'>
							<img :src="icon_look" class="imageC" @click='lookpens = true;applyid=record.applyid'>
						</div>
						<div class="popoverView">
							<img @click="pdfEvent(record)" :src="record.pdfShowBol ? icon_pdf1 : icon_pdf"
								class="imageC" style="width: 1.3rem !important;">
						</div>
						<div class="popoverView popoverView3">
							<ediotitem v-if='ipoAdmin' :ipoAdmin='ipoAdmin' :record='record' 
								:missionflag='params.missionflag' @child='handclose'></ediotitem>
						</div>
					</div>
				</div>
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<div :class="['pdfview',pdfShow ? 'pdfShow' : '']" @click="pdfShowUNEvent()">
			<div class="pdfviewIn">
				<div class="pdfTitle">
					<img @click.stop="printEvent()" src="../../image/icon_dayin.png">
				</div>
				<iframe id="iframePdf1" :src="allurl" style="width: 100%; height: 100%" frameborder="0"></iframe>
				<iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl" frameborder="0"></iframe>
			</div>
		</div>
		<!-- <handitemqi :pared='pared' v-if='isopen' @child='handback'></handitemqi>
		<handitemwaichu :pared='pared' v-if='waichu' @child='handback'></handitemwaichu>
		<handitemjiaban v-if='jiaban' @child='handback' :pared='pared'></handitemjiaban> -->
		<!-- <handme v-if='isopens' @child='handback' :applyid='applyid'></handme> -->
		<handlook v-if='lookpens' @child='handback' :applyid='applyid'></handlook>
		<handwenju v-if='wenju' @child='handback' :pared='pared'></handwenju>
		<handhome v-if='isopen||waichu||jiaban||isopens' :itemobj='pared' @child='handback' :applyid='applyid'></handhome>
		<!-- 搜索无结果弹窗 -->
		<div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	import icon_one from '../../image/lea/icon1_1.png';
	import icon_one1 from '../../image/lea/icon1.png';
	import icon_two from '../../image/lea/icon2_1.png';
	import icon_two1 from '../../image/lea/icon2.png';
	import icon_three1 from '../../image/lea/icon3_1.png';
	import icon_three2 from '../../image/lea/icon3_2.png';
	import icon_three4 from '../../image/lea/icon4.png';
	import icon_three from '../../image/lea/icon3.png';
	import icon_four from '../../image/lea/save.png';
	import icon_pdf from '../../image/icon_pdf.png';
	import icon_pdf1 from '../../image/icon_pdf1.png';

	import handitemqi from './components/handitemqi';
	import handme from './components/handme';
	import handlook from './components/handlook';
	import handitemwaichu from './components/handitemwaichu';
	import handitemjiaban from './components/handitemjiaban';
	// import pushbtn from './components/pushbtn.vue'
	import ediotitem from './components/ediotitem.vue'
	import task from './components/task.vue'
	import handwenju from './components/handwenju.vue'
	import handhome from './comhome/handhome.vue'

	import {
		saveFileToLink
	} from 'web-downloadfile';
	export default {
		components: {
			ediotitem,
			handwenju,
			// ediotable,
			handhome,
			handme,
			handlook,
			handitemqi,
			handitemjiaban,
			handitemwaichu,
			task,
		},
		data() {
			return {
				routeFlag:'sqjq_bm',
				ishandout: false,
				icon_amd: require('@/image/adm.png'),
				icon_amd1: require('@/image/adm1.png'),
				pared: {},
				applyid: '',
				rewulist: {},
				isopens: false,
				lookpens: false,
				icon_pdf,
				icon_pdf1,
				allurl: '',
				pdfUrl: '',
				pdfBolUrl: '',
				pdfShow: false,
				jiaban: false,
				wenju: false,
				isopen: false,
				waichu: false,
				icon_look: require('@/image/lea/look.png'),
				icon_one,
				icon_one1,
				icon_two,
				icon_two1,
				icon_three,
				icon_three1,
				icon_three2,
				icon_three4,
				icon_four,
				attenceAdmin2: this.$store.state.rolesdata.indexOf('attenceAdmin2') >= 0,
				//: "編輯管理員": "ipoAdmin"有新增 编辑权限     审批管理员 ipoAduitAdmin 审批权限
				ipoAdmin: this.$store.state.rolesdata.indexOf('attenceAdmin1') >= 0 || this.$store.state.rolesdata.indexOf(
					'attenceAdmin2') >= 0 || this.$store.state.rolesdata.indexOf('attenceAdmin3') >= 0,
				ipoAduitAdmin: this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0,
				attenceAdmin3: this.$store.state.rolesdata.indexOf('attenceAdmin3') >= 0,
				admintypeArr: [{
						text: '處理中',
						value: '0'
					},
					{
						text: '認購中',
						value: '1'
					},
					{
						text: '待上市',
						value: '2'
					},
					{
						text: '已上市',
						value: '3'
					},
				],
				admintypeArrs: [{
						text: '全部',
						value: ''
					},{
						text: '假期',
						value: 1
					},
					{
						text: '外出',
						value: 2
					}, {
						text: '加班',
						value: 3
					}, {
						text: '辦工用品',
						value: 4
					},
				],
				khtypeArr: [{
						text: '全部',
						value: ''
					},
					{
						text: '已审核',
						value: 2
					},
					{
						text: '未审核',
						value: 1
					},
				],
				tzPageNum: '',
				columns: [{
						// title: '',
						dataIndex: '',
						align: 'left',
						width: '4%',
						slots: {
							title: 'alltext'
						},
					},
					// {
					// title: '',
					// dataIndex: '',
					// align: 'right',
					// width: '3%',
					// slots: {
					// 	title: 'alltext'
					// },
					// scopedSlots: {
					// 	customRender: 'hot_status'
					// }
					// },
					{
						title: '員工姓名',
						dataIndex: 'realname',
						align: 'center',
						width: '10%',
						// ellipsis: true,
					},
					{
						title: '申請類別',
						dataIndex: '',
						align: 'center',
						width: '10%',
						scopedSlots: {
							customRender: 'type'
						}
					},
					{
						title: '提交時間',
						dataIndex: '',
						align: 'center',
						width: '10%',
						scopedSlots: {
							customRender: 'createtime'
						}
					},
					{
						title: '申請天數/時數',
						dataIndex: 'day_hour',
						align: 'center',
						width: '10%'
					},
					{
						title: '批核進度',
						dataIndex: '',
						align: 'center',
						width: '28%',
						scopedSlots: {
							customRender: 'schedule'
						}
					},
					{
						title: '批核時間',
						dataIndex: 'audittime',
						align: 'center',
						width: '10%'
					},
					{
						title: '批核狀況',
						dataIndex: '',
						align: 'center',
						width: '10%',
						scopedSlots: {
							customRender: 'status'
						}
					},
					{
						title: '操作',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [],
				selectedRows: [], //checkbox
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					searchstr: '',
					perPage: 10, //每頁條目數
					ename: '', //李百控股    股票名稱
					stockcode: '', //股票代碼
					department: '', //處理中，認購中，待上市，已上市 //上市狀態
					applytype: '', //類型 1 假期申請 2 外出 3加班
					status: '', //保薦機構
					cn_planned_industry_name_cn: '', //服務業 //上市行業
					begindate: '', //認購起始日期
					enddate: '', //認購截止日期
					timeDate: [],
					missionflag: ''
				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.messLoad();
		},
		methods: {
			handleCancel(ev){
                this.ishandout = false
			},
			handleClear(val){
                if (!this.params.ename) {
                    this.messLoad()
                }
            },
			fourfn(record) {
				if (1 == record.isuserself) {
					this.pared = record
					//是不是本人
					if (1 == record.type) { //假期
						this.wenju = true

					} else if (2 == record.type) { //外出
						if (record.schedule == 4) {
							this.applyid = record.applyid
							this.isopens = true
						} else {
							this.waichu = true
						}
					} else if (3 == record.type) { //加班
						this.jiaban = true
					} else if (4 == record.type) { //wenju 
						this.isopen = true

					}
				}
			},
			pdfEvent(record) {
				let str = this.$api.pdfs;
				let url = this.$api.getAttenceApplyPdf;
				// url += '?m=' + Date.parse(new Date())
				url += '?applyid=' + record.applyid + '&token=' + this.$store.state.token + '&m=' + Date.parse(new Date())
				this.allurl = str + url
				let _this = this;
				_this.pdfUrl = url
				https.fetchGetPdf(_this.pdfUrl).then((data) => {
					let blob = new Blob([data], {
						type: 'application/pdf'
					});
					_this.blob = blob;
					let b = window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err => {
					console.log(err);
				});

				setTimeout(() => {
					this.pdfShow = true;
				}, 500);
				// window.open(this.$api.openurls+ "/dalinji")
			},
			printEvent() {
				let _this = this; //toPrintIframe
				const printIframe = document.getElementById("toPrintIframe");
				let frameWindow = printIframe.contentWindow;
				frameWindow.print();
				setTimeout(() => {
					window.URL.revokeObjectURL(_this.blob);
				}, 500)
				//隐藏不想打印的部分

				// 实现打印
				// var bdhtml = document.getElementById("iframePdf1").innerHTML;
				// var sprnstr = "<!--startprint-->";
				// var eprnstr = "<!--endprint-->";
				// var prnhtml = bdhtml.substr(bdhtml.indexOf(sprnstr) + 17);
				// var prnhtml = prnhtml.substring(0, prnhtml.indexOf(eprnstr));
				// bdhtml = prnhtml;
				// window.print();
				// 完成后不隐藏
			},

			handopen(record) {
				let str = this.$api.pdfs;
				// let url = this.$api.getOrderHistoryPdf
				let url = this.$api.getOrderHistoryPdfs
				url += '?m=' + Date.parse(new Date())
				for (let key in this.form) {
					url += '&' + key + '=' + this.form[key]
				}
				this.allurl = str + url
				let _this = this;
				_this.pdfUrl = url
				https.fetchGetPdf(_this.pdfUrl).then((data) => {
					let blob = new Blob([data], {
						type: 'application/pdf'
					});
					_this.blob = blob;
					let b = window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err => {
					console.log(err);
				});

				setTimeout(() => {
					this.pdfShow = true;
				}, 500);
				// window.open(this.$api.openurls+ "/dalinji")
			},
			pdfShowUNEvent() {
				this.pdfShow = false;
				this.messLoad();
			},
			handback() {
				this.isopen = false;
				this.waichu = false;
				this.jiaban = false;
				this.isopens = false;
				this.lookpens = false
				this.wenju = false;
				this.pared = {}
				this.applyid = ''
				this.messLoad();
			},
			fandfn(val) {
				this.applyid = val.applyid
				this.params.schedule = ''
				if (val.status == "外出記錄" && val.amount > 0) {
					this.isopens = true
				} else if (val == 'back') {
					this.params.missionflag = 0
					this.params.applytype = ''
				} else {
					this.params.missionflag = 1
					this.params.applytype = val.ind + 1
				}
				this.messionEvent()
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},
			handDelect(record) {
				console.log(record);
				this.pared = record
				if (1 == record.type) { //假期
					this.wenju = true
				} else if (2 == record.type) { //外出
					this.waichu = true
				} else if (3 == record.type) { //加班
					this.jiaban = true
				} else if (4 == record.type) {
					this.isopen = true

				}
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
				this.params.begindate = this.params.timeDate[0] ? App.oDate.secsTime3(this.params.timeDate[0]
						._d) : '',
					//認購截止日期
					this.params.enddate = this.params.timeDate[1] ? App.oDate.secsTime3(this.params.timeDate[1]
						._d) : ''
			},
			handclose(val) {
				this.isopen = false
				this.messLoad();
			},
			messLoad() {
				this.params.token = this.$store.state.token
				this.selectedRows = []
				this.$ajax({
					method: 'post',
					url: this.$api.getAttenceApplyList,
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.applyList
						this.columnsData.map(ev => {
							for (let key in ev) {
								ev['pdfShowBol'] = false;
								ev['shShowBol'] = false;
							}
						})
						console.log(this.columnsData);
						this.rewulist = res.data.rewulist
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
						if (this.params.ename ||  this.params.applytype || this.params.department || this.params.status || this.this.params.begindate) {
							if (this.columnsData.length<=0) {
								this.ishandout = true
							}
						}
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.params.missionflag = false;
				this.messLoad();
			},
			clearEvent() {
				this.params = {}
				this.params = {
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					ename: '', //李百控股    股票名稱
					stockcode: '', //股票代碼
					department: '', //處理中，認購中，待上市，已上市 //上市狀態
					applytype: '',
					status: '', //保薦機構
					cn_planned_industry_name_cn: '', //服務業 //上市行業
					begindate: '', //認購起始日期
					enddate: '', //認購截止日期
					timeDate: [],
					missionflag: ''
				}
				this.messLoad();
			},
			messionEvent() {
				this.params.pageNum = 1;
				this.messLoad();
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
		},
	};
</script>
<style lang="scss" scoped>
	@import "./leaveapplication.css";
</style>
<style lang='scss'>
	#leaveapplication {
		.pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 99;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 40vw;
			height: 80vh;
			left: calc(50% - 20vw);
			top: 5vh;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
	}
</style>
